<template>
    <a class="btn btn-secondary" :href="route_back">Вернуться</a>
    <div v-for="(right, right_index) in rights">
        <span class="fs-4">
            {{ right.title }}
            <input v-model="right.allow" class="form-check-input" type="checkbox" id="right-{{right.service_id}}"
                   v-on:change="changeRight(right.allow, right.service_id, right_index)">
            <!--<a class="btn btn-danger" v-if="right.allow" href="" v-on:click="disableRight(right.service_id, right_index)">Запретить</a>
            <a class="btn btn-success" v-else href="" v-on:click="allowRight(right.service_id, right_index)">Разрешить</a>-->
        </span>
        <div v-if="right.allow">
            <div v-for="(action, action_index) in right.actions">
                <input v-model="action.allow" class="form-check-input" type="checkbox" id="right-{{action.name}}"
                       v-on:change="changeAction(action.allow, right.service_id, action.name, right_index, action_index)">
                <!--<a class="btn btn-danger" v-if="action.allow" href=""
                   v-on:click="disableAction(right.service_id, action.name, right_index, action_index)">Запретить</a>
                <a class="btn btn-success" v-else href=""
                   v-on:click="allowAction(right.service_id, action.name, right_index, action_index)">Разрешить</a>-->
                <span class="fs-5">{{ action.name }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import AdminRole from "../../../../models/AdminRole";

export default {
    name: "GroupRightComponent",
    props: {
        id: {
            type: [Number, String],
            default: 0
        },
        route_back: String,
        route_allow_right: String,
        route_disable_right: String,
        route_allow_action: String,
        route_disable_action: String,
        rights_data: {
            type: [Object, Array],
            default: [
                {
                    service_id: 0,
                    title: '',
                    actions: [
                        {
                            allow: false,
                            name: ''
                        }
                    ]
                }
            ]
        }
    },
    data() {
        return {
            rights: [],
            admin: new AdminRole({
                route_allow_right: this.route_allow_right,
                route_disable_right: this.route_disable_right,
                route_allow_action: this.route_allow_action,
                route_disable_action: this.route_disable_action
            })
        }
    },
    methods: {
        changeRight: function (allow, service_id, right_index) {``
            if (allow) {
                this.allowRight(service_id, right_index);
            } else {
                this.disableRight(service_id, right_index);
            }
        },
        changeAction: function (allow, service_id, name, right_index, action_index) {
            if (allow) {
                this.allowAction(service_id, name, right_index, action_index);
            } else {
                this.disableAction(service_id, name, right_index, action_index);
            }
        },
        disableRight: async function (service_id, right_index = 0) {
            event.preventDefault();
            let result = await this.admin.disableRight(service_id);
            if (result) {
                this.rights[right_index].allow = false;
                this.rights[right_index].actions.forEach((item, key) => {
                    this.rights[right_index].actions[key].allow = false;
                });
            } else {
                console.log('error: disable_right');
                this.rights[right_index].allow = true;
            }
        },
        allowRight: async function (service_id, right_index = 0) {
            event.preventDefault();
            let result = await this.admin.allowRight(service_id);
            if (result) {
                this.rights[right_index].allow = true;
                this.rights[right_index].actions.forEach((item, key) => {
                    this.rights[right_index].actions[key].allow = false;
                });
            } else {
                console.log('error: allow_right');
                this.rights[right_index].allow = false;
            }
        },
        disableAction: async function (service_id, action, right_index = 0, action_index = 0) {
            event.preventDefault();
            let result = await this.admin.disableAction(service_id, action);
            if (result) {
                this.rights[right_index].actions[action_index].allow = false;
            } else {
                console.log('error: disable_action');
                this.rights[right_index].actions[action_index].allow = true;
            }
        },
        allowAction: async function (service_id, action, right_index = 0, action_index = 0) {
            event.preventDefault();
            let result = await this.admin.allowAction(service_id, action);
            if (result) {
                this.rights[right_index].actions[action_index].allow = true;
            } else {
                console.log('error: allow_action');
                this.rights[right_index].actions[action_index].allow = false;
            }
        }
    },
    mounted() {
        this.rights = this.rights_data;
    }
}
</script>

<style scoped>
.page-title {
    font-family: Helvetica, Arial, sans-serif;
    font-size: 16px;
    font-weight: bold;
}
</style>
